import * as type from '../actions/types';

const initialState = {
  revenueAnalytics: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  heatmapData: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  performanceComparison: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
  popularItems: {
    data: {},
    fetching: false,
    error: false,
    errorMessage: '',
    success: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_REVENUE_ANALYTICS_PENDING:
      return {
        ...state,
        revenueAnalytics: {
          ...state.revenueAnalytics,
          fetching: true,
          errorMessage: false,
          success: false,
        },
      };
    case type.FETCH_REVENUE_ANALYTICS_SUCCESS:
      return {
        ...state,
        revenueAnalytics: {
          ...state.revenueAnalytics,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_REVENUE_ANALYTICS_FAILURE:
      return {
        ...state,
        revenueAnalytics: {
          ...state.revenueAnalytics,
          error: true,
          errorMessage: action.payload,
          fetching: false,
        },
      };

    case type.FETCH_HEATMAP_DATA_PENDING:
      return {
        ...state,
        heatmapData: {
          ...state.heatmapData,
          fetching: true,
          errorMessage: false,
          success: false,
        },
      };
    case type.FETCH_HEATMAP_DATA_SUCCESS:
      return {
        ...state,
        heatmapData: {
          ...state.heatmapData,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_HEATMAP_DATA_FAILURE:
      return {
        ...state,
        heatmapData: {
          ...state.heatmapData,
          error: true,
          errorMessage: action.payload,
          fetching: false,
        },
      };

    case type.FETCH_PERFORMANCE_COMPARISON_PENDING:
      return {
        ...state,
        performanceComparison: {
          ...state.performanceComparison,
          fetching: true,
          errorMessage: false,
          success: false,
        },
      };
    case type.FETCH_PERFORMANCE_COMPARISON_SUCCESS:
      return {
        ...state,
        performanceComparison: {
          ...state.performanceComparison,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_PERFORMANCE_COMPARISON_FAILURE:
      return {
        ...state,
        performanceComparison: {
          data: {},
          error: true,
          errorMessage: action.payload,
          fetching: false,
          success: false,
        },
      };

    case type.FETCH_POPULAR_ITEMS_PENDING:
      return {
        ...state,
        popularItems: {
          ...state.popularItems,
          fetching: true,
          error: false,
          errorMessage: '',
          success: false,
        },
      };
    case type.FETCH_POPULAR_ITEMS_SUCCESS:
      return {
        ...state,
        popularItems: {
          ...state.popularItems,
          data: action.payload,
          fetching: false,
          error: false,
          errorMessage: '',
          success: true,
        },
      };
    case type.FETCH_POPULAR_ITEMS_FAILURE:
      return {
        ...state,
        popularItems: {
          data: {},
          error: true,
          errorMessage: action.payload,
          fetching: false,
          success: false,
        },
      };

    default:
      return state;
  }
};
